// We use geoip.nekudo.com/api service here
// It is free and unlimited, but accuracy is not perfect
// Ex. detects wrong city name
import axios from 'axios'
import logger from 'helpers/logger'
import { API_HOST } from 'constants/apiHost'


export default () => axios({
    method: 'get',
    url: `${API_HOST}/ipdata/`
})
.then(res => res.data)
.catch(error => {
    logger('Retrieving geo data failed', 'warn')
    return Promise.resolve('unidentified')
})
